export default (prefix) => {
  return {
    path: 'video',
    name: `${prefix}TestVideo`,
    meta: {subPage: true},
    component: () => import('@/pages/shared_pages/test_video/sh_TestVideo')
  };
};
